import { render } from "./Steps.vue?vue&type=template&id=13c41f58"
import script from "./Steps.vue?vue&type=script&lang=ts"
export * from "./Steps.vue?vue&type=script&lang=ts"
script.render = render

export default script